import { renderRichText } from 'gatsby-source-contentful/rich-text';

import webinarBackup from '../images/webinar-backup.jpg';
import { addTrailingSlash } from './textTools';

export const sortByPublishDate = (a, b) => {
  if (a.publishDate < b.publishDate) {
    return 1;
  } else if (a.publishDate > b.publishDate) {
    return -1;
  }
  return 0;
};

export const sortByCreatedDate = (a, b) => {
  if (a.createdAt < b.createdAt) {
    return 1;
  } else if (a.createdAt > b.createdAt) {
    return -1;
  }
  return 0;
};

export const createFullPostList = (posts = [], walledContent = [], webinars = []) => {
  const mappedPosts = posts.map((p) => {
    return {
      title: p.title,
      description: p.articleDescription,
      publishDate: p.publishDate,
      heroImage: p?.heroImage?.file?.url,
      type: flattenType(p),
      theme: flattenThemes(p),
      slug: p.slug,
      listingDescription: p?.listingDescription?.listingDescription,
    };
  });

  const mappedWalled = walledContent.map((p) => {
    return {
      title: p.title,
      description: p.description,
      publishDate: p.publishDate,
      heroImage: p?.heroImage?.file?.url,
      type: flattenType(p),
      theme: flattenThemes(p),
      slug: p.slug,
      listingDescription: p?.listingDescription?.listingDescription,
    };
  });

  const mappedWebinar = webinars
    .filter((w) => !w.inviteOnly) // GraphQL ne query is not filtering these out
    .map((p) => {
      return {
        title: p.title,
        description: p?.description?.description,
        publishDate: p.publishDate,
        heroImage: p?.heroImage?.file?.url || webinarBackup,
        type: 'Video',
        theme: flattenThemes(p),
        slug: p.slug,
        listingDescription: p?.listingDescription?.listingDescription,
      };
    });

  return [...mappedPosts, ...mappedWalled, ...mappedWebinar].sort((a, b) => {
    if (a.publishDate > b.publishDate) {
      return 1;
    } else if (a.publishDate < b.publishDate) {
      return -1;
    }
    return 0;
  });
};

export const getUrl = (item) => {
  let slug = addTrailingSlash(item.slug);
  let url;
  switch (item.__typename) {
    case 'ContentfulPageBlogPost': {
      url = `/blog/${slug}`;
      break;
    }
    case 'ContentfulPageResource': {
      url = `/resources/${slug}`;
      break;
    }
    default: {
      url = '/blog/';
      break;
    }
  }
  return url;
};

export const mapDeepDiveCard = (data, skip) => {
  if (skip) return data;
  switch (data.__typename) {
    case 'ContentfulComponentSimpleContent': {
      let copy = '';
      if (data?.body?.raw) {
        copy = renderRichText(data.body);
      }
      return {
        image: data.image,
        pageMetaData: { ogImage: data.image },
        title: data.title,
        contentType: { title: data.subtitle },
        articleDescription: { articleDescription: copy },
        url: data.linkUrl,
        linkLabel: data.linkLabel,

        ...data,
      };
    }
    case 'ContentfulPageBlogPost':
      return {
        url: `/blog/${data.slug}`,
        linkLabel: 'Blog Post',
        ...data,
      };
    case 'ContentfulPageResource':
      return {
        url: `/resources/${data.slug}`,
        linkLabel: data.linkLabel || data.contentType?.viewLabel,
        ...data,
      };
    default:
      return data;
  }
};

const flattenThemes = (post) => {
  if (!post.theme) {
    return [];
  }
  let themes = [];
  post.theme.forEach((t) => themes.push(t.themeName));
  return themes;
};

const flattenType = (post) => {
  if (!post.type) return;
  return post.type.typeName;
};
